var _style, _g, _g2, _g3, _rect, _rect2, _rect3, _g4, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEtBurgerAntikWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 353.3 183.7",
    style: {
      enableBackground: "new 0 0 353.3 183.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#FFFFFF;}\n\t.st2{display:inline;fill:#262324;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ANTI_x5F_white_x5F_alier",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.1,171.8l-23.2-11.6V75.4L167.4,64v-8h-28.5V27.9h-14.5l-9.2,34.3v56.5l0,0c-0.3,15.3-5.6,28.1-15.5,37.2 c-9.8,9-23.1,13.4-36.7,12.3c-22.1-2.2-37.5-19.5-37.5-42.1c0-12.7,6.8-25.4,17.7-33c11.6-8.1,26.1-9.6,40.9-4.4l7.5-9.5L36.7,27.9 h49.9L96,61h8.5V6.4H12.4v22l52.1,43.5L61,71.4c-0.6-0.1-1-0.1-1-0.1c-2.7-0.3-5.3-0.5-7.8-0.5c-16,0-27,6.6-33.8,12.6 C6.9,93.5,0,108.9,0,124.3c0,15.6,6.2,30,17.5,40.8c11.6,11,27.8,17.2,45.6,17.5c32.9,0.4,49.9-20.5,58.4-38.1l0.4-0.9l11.7,6.3 l-16.3,30.2H162v-8.3H162.1L162.1,171.8z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "GRO_x5F_black_x5F_Et",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173.9,55.1h-32.2V29h-25.6l0,0l0,0v67.1c0,39-15.9,66.4-51.2,66.8c-21.1,0-39.8-14.3-39.4-38.2 c0.4-29.9,27.8-47,60.7-34.9l10.3-13.5L41.7,28.9H116V5.5H10.6v24.1L57,69.3c-35.5-3.5-57,27.2-57,55c0,32.2,24.9,59.2,61.9,59.4 c25.2,0.1,42-11.2,52.6-26.5h1.6v23.9h25.6v-104h32.2V55.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 56.5,
    className: "st3",
    width: 144.5,
    height: 19.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 107.8,
    className: "st3",
    width: 144.5,
    height: 19.8
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 159,
    className: "st3",
    width: 144.5,
    height: 19.8
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M162.1,171l-22.9-11.4V75.7l28.2-11.2v-8h-28.2V30.6h-14.4l-9.1,31.9v55.9l0,0c-0.3,15.1-5.6,27.8-15.3,36.7 c-9.6,8.9-22.9,13.3-36.3,12.2C42.2,165.2,27,148.1,27,125.8c0-12.6,6.7-25.1,17.5-32.6c11.4-8,25.8-9.5,40.4-4.3l7.4-9.5 L38.1,28.7h49.3l9.3,32.8h7.7v-54H14.1v21.7l51.5,43l-3.4-0.5c-0.6-0.1-0.9-0.1-1-0.1c-2.7-0.3-5.2-0.5-7.7-0.5 c-15.8,0-26.8,6.5-33.5,12.4C8.6,93.6,1.8,108.8,1.8,124.1c0,32.3,26.8,57.1,62.4,57.6c32.6,0.5,49.4-20.3,57.8-37.7l0.4-0.9 l11.6,6.2l-16.1,29.8h44.2V171z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st4",
    width: 353.3,
    height: 183.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtBurgerAntikWhite);
export default __webpack_public_path__ + "static/media/et-burger-antik-white.6870a8d68100da4d64147c8e3d5ffb84.svg";
export { ForwardRef as ReactComponent };